import { authenticatedFetchJson } from "@/services/utils/authenticatedFetch";

interface DatenadapterCredentials {
  username: string;
  password: string;
  apiUrl: string;
}

export async function saveDatenadapterCredentials(
  username: string,
  password: string,
  apiUrl: string
): Promise<DatenadapterCredentials> {
  try {
    const data = await authenticatedFetchJson<DatenadapterCredentials>("/api/datenadapter-credentials", {
      method: "POST",
      body: JSON.stringify({ username, password, apiUrl }),
    });

    return {
      username: data.username || username,
      password: data.password || password,
      apiUrl: data.apiUrl || apiUrl
    };
  } catch (error) {
    console.error("Error saving Datenadapter credentials:", error);
    throw error;
  }
}
